import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import editorialTeamLogo from "@/assets/brand/perceptica-media-intelligence-logo.jpg.asset.json";
import { EDITORIAL_TEAM_NAME } from "@/content/authors";
import { cn } from "@/lib/utils";

type PostBylineProps = {
  date: string;
  updated?: string;
  locale: "en" | "bg";
  compact?: boolean;
  className?: string;
};

export function PostByline({ date, updated, locale, compact = false, className }: PostBylineProps) {
  const published = new Date(date);
  const formattedDate = published.toLocaleDateString(locale === "bg" ? "bg-BG" : "en-US", {
    year: "numeric",
    month: compact ? "short" : "long",
    day: "numeric",
  });
  const label = locale === "bg" ? "Публикувано на" : "Published on";

  return (
    <div className={cn("flex items-center gap-2.5 text-muted-foreground", className)}>
      <Avatar
        className={cn(
          "rounded-md border border-border bg-background",
          compact ? "h-6 w-6" : "h-8 w-8",
        )}
      >
        <AvatarImage
          src={editorialTeamLogo.url}
          alt="Perceptica Editorial Team"
          className="object-cover"
        />
        <AvatarFallback className="rounded-md text-[10px] font-semibold">P</AvatarFallback>
      </Avatar>
      <p className={cn("flex min-w-0 flex-wrap items-center gap-x-1.5 gap-y-0.5", compact ? "text-[11.5px]" : "text-[13px]")}> 
        <span className="font-medium text-foreground/80">{EDITORIAL_TEAM_NAME}</span>
        <span aria-hidden>·</span>
        <span>
          {label}{" "}
          <time dateTime={date}>{formattedDate}</time>
        </span>
        {updated && (
          <>
            <span aria-hidden>·</span>
            <span>
              {locale === "bg" ? "Актуализирано:" : "Updated:"}{" "}
              <time dateTime={updated}>
                {new Date(updated).toLocaleDateString(locale === "bg" ? "bg-BG" : "en-US", {
                  year: "numeric",
                  month: compact ? "short" : "long",
                  day: "numeric",
                })}
              </time>
            </span>
          </>
        )}
      </p>
    </div>
  );
}